/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Setup_IncompleteInputs */

const fr_api_drive_setup_incomplete = /** @type {(inputs: Api_Drive_Setup_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminez la configuration Drive avant de relever la boîte.`)
};

const en_api_drive_setup_incomplete = /** @type {(inputs: Api_Drive_Setup_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish the Drive setup before scanning the mailbox.`)
};

/**
* | output |
* | --- |
* | "Finish the Drive setup before scanning the mailbox." |
*
* @param {Api_Drive_Setup_IncompleteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_setup_incomplete = /** @type {((inputs?: Api_Drive_Setup_IncompleteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Setup_IncompleteInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_setup_incomplete(inputs)
	return fr_api_drive_setup_incomplete(inputs)
});